import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Field} from 'formik';
import {useSelector} from "react-redux";

const ChooseColor = ({color}) => {
    const {tagCategories} = useSelector(state => state.tagCategories)

    const [availableColors, setAvailableColors] = useState([])

    useEffect(() => {
        const COLORS = [
            "#14080E",
            "#383C43",
            "#1A535C",
            "#00800b",
            "#3D8A59",
            '#0d3b66',
            '#054789',
            "#00abb2",
            "#33658a",
            '#0A77E6',
            "#347FC4",
            "#5a0054",
            "#7F2AA7",
            "#A4132B",
            "#ff7c5d",
            "#AF3B6E",
            "#C492B1",
            "#C26614",
            "#B88100",
            "#E6AF2E",
        ]

        let colors = []
        tagCategories.forEach((category) => {
            colors.push(category.color)
        })

        let array

        array = COLORS.filter(obj => {
            return colors.indexOf(obj) === -1;
        });
        if (color) {
            array.splice(COLORS.indexOf(color), 0, color)
        }

        setAvailableColors(array)
    }, [color, tagCategories])

    const displayColor = (color) => {
        return (
            <Color style={{backgroundColor: color}}/>
        )
    }

    return (
        <Container>
            {availableColors.length > 0 &&
            <>
                <label> Choisir une couleur : </label>
                <Wrapper>
                    {availableColors.map((c, index) => (
                        <label key={c + '/' + index}>
                            <Field
                                key={index}
                                type="radio"
                                value={c}
                                name="color"
                            />
                            {displayColor(c)}
                        </label>
                    ))}
                </Wrapper>
            </>

            }

        </Container>
    )
}


const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  height: 120px;
  
  label > input {
    opacity: 0;
    position: absolute;
  }

  label > input + div {
    display: flex;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    background-color: transparent;
    justify-content: space-evenly;
    align-items: center;
    margin-right: 0.5em;
    font-size: 0.9em;
  }

  label > input:checked + div {
    width: 3rem;
    height: 3rem;
  }
`

const Color = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  cursor: pointer;
`


export default ChooseColor